// ?use_ios_ui — twin of iOS PoweredByFooter: "Powered by AUTOVIZ vX" on a
// dark capsule, centred 5px off the bottom edge. Decorative — it never
// takes a touch, so taps still reach the AR view.

import logoLight from '@/assets/autoviz-logo-light.png'
import { IOS_UI_FONT } from '@/components/ios-ui/ios-ui-palette/ios-ui-palette'

const FONT_PX = 8
/** The wordmark is ~35% of the asset's height, so the frame is sized off
 *  that to match the label's cap height. */
const LOGO_PX = (FONT_PX * 0.72) / 0.35

export function PoweredByFooter({ version }: { version: string }) {
  return (
    <div
      data-testid="ios-powered-by"
      aria-label={`Powered by AutoViz, version ${version}`}
      style={{
        position: 'fixed',
        left: '50%',
        bottom: 5,
        transform: 'translateX(-50%)',
        display: 'flex',
        alignItems: 'center',
        gap: 5,
        padding: '4px 9px',
        borderRadius: 999,
        background: 'rgba(0, 0, 0, 0.55)',
        fontFamily: IOS_UI_FONT,
        fontSize: FONT_PX,
        fontWeight: 500,
        whiteSpace: 'nowrap',
        pointerEvents: 'none',
        zIndex: 15,
      }}
    >
      <span style={{ color: 'rgba(255,255,255,0.75)' }}>Powered by</span>
      <img src={logoLight} alt="" style={{ height: LOGO_PX }} />
      <span data-testid="ios-powered-by-version" style={{ color: 'rgba(255,255,255,0.55)' }}>{`v${version}`}</span>
    </div>
  )
}
